import { Route, Switch } from 'react-router';
import { AccountSettings } from '../views/Settings/Account';
import { NotificationsSettings } from '../views/Settings/Notifications';
import { Security } from '../views/Settings/PasswordChange/Password';
import { PaymentsSettings } from '../views/Settings/Payments';
import { Settings } from '../views/Settings/Settings';
import { TeamSettings } from '../views/Settings/Team';
// import { VirtualOffice } from '../views/Settings/VirtualOffice';
import {
  SETTINGS_ACCOUNT,
  SETTINGS_NOTIFICATIONS,
  SETTINGS_PAYMENTS,
  SETTINGS_SECURITY,
  SETTINGS_TEAM_SETTINGS
  // SETTINGS_VIRTUAL_OFFICE
} from './routes';

export const SettingsRoutes = ({
  isCanadaRestrictedUser
}: {
  isCanadaRestrictedUser: boolean;
}) => (
  <Settings>
    <Switch>
      <Route
        exact
        path={`${SETTINGS_ACCOUNT}`}
        render={() => <AccountSettings />}
      />

      <Route exact path={`${SETTINGS_SECURITY}`} render={() => <Security />} />

      <Route
        exact
        path={`${SETTINGS_PAYMENTS}`}
        render={() => <PaymentsSettings />}
      />

      {/* <Route
        exact
        path={`${SETTINGS_VIRTUAL_OFFICE}`}
        render={() => <VirtualOffice />}
      /> */}

      <Route
        exact
        path={`${SETTINGS_NOTIFICATIONS}`}
        render={() => <NotificationsSettings />}
      />

      {!isCanadaRestrictedUser && (
        <Route
          exact
          path={`${SETTINGS_TEAM_SETTINGS}`}
          render={() => <TeamSettings />}
        />
      )}
    </Switch>
  </Settings>
);
